// stores/useTimetableTypesStore.ts
import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

interface TimetableType {
  id: string;
  name: string;
  session: string;
  status: 'active' | 'inactive';
}

interface TimetableTypesState {
  timetableTypes: TimetableType[];
  loading: boolean;
  error: string | null;
  fetchTimetableTypes: () => Promise<void>;
}

export const useTimetableTypesStore = create<TimetableTypesState>((set) => ({
  timetableTypes: [],
  loading: false,
  error: null,

  fetchTimetableTypes: async () => {
    set({ loading: true, error: null });

    try {
      const response = await apiClient.get('timetable-types');
      const { data } = response.data; // response.data.data → array

      set({
        timetableTypes: Array.isArray(data) ? data : [],
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load timetable types';

      set({
        loading: false,
        error: errorMessage,
      });
    }
  },
}));